import { Box, Flex, Text, Tooltip } from '@chakra-ui/react'
import { useState } from 'react'

interface IPatientData {
  title: string
  info: string | undefined
  iconCopy?: React.ReactElement<any, string | React.JSXElementConstructor<any>>
}

export default function PatientInfoItem({
  title,
  info,
  iconCopy,
}: IPatientData) {
  const [isCopy, setIsCopy] = useState(false)

  const makeCopy = (text: string) => {
    navigator.clipboard.writeText(text)
    setIsCopy(true)
  }

  return (
    <Flex alignItems={'start'}>
      <Box w={'40%'}>
        <Text fontSize="sm" color={'brand.lightGrayText'} mr={1}>
          {title}
        </Text>
      </Box>
      <Flex w={'60%'}>
        <Text fontSize="sm">{iconCopy ? info?.slice(0, 6) : info}</Text>
        {iconCopy && info && (
          <Tooltip
            label={isCopy ? 'Copied' : 'Copy'}
            onClose={() => setIsCopy(false)}
            closeDelay={1000}
          >
            <Box
              onClick={() => makeCopy(info)}
              color="#999FA9"
              aria-label="Copy ID"
              mx={2}
            >
              {iconCopy}
            </Box>
          </Tooltip>
        )}
      </Flex>
    </Flex>
  )
}
